import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CommonService } from "../../../services/common/common.service";
import { GlobalContext } from "../../../store";
import { Box } from "@material-ui/core";
import SettingsHead from "../../../modules/settings/shared/settings-head/settings-head.component";
import SupportBlockComponent from "../../../components/support/support.component";
import RiskLevelManagementContentComponent from "../../../modules/settings/components/risk-level-management/risk-level-management-content.component";

const RiskLevelManagementPage = () => {
  const { t } = useTranslation();
  const commonService: CommonService = new CommonService();
  const { setPageTitle } = useContext(GlobalContext);

  useEffect(() => {
    setTimeout(() => {
      commonService.setTitle(t("PAGE_META_TITLES.RISK_LEVEL_MANAGEMENT"));
      setPageTitle(t("PAGE_META_TITLES.RISK_LEVEL_MANAGEMENT"));
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <SettingsHead
        title={t("PAGES_HEAD.SETTINGS.RISK_LEVEL_MANAGEMENT_TITLE")}
        subTitle={t("PAGES_HEAD.SETTINGS.RISK_LEVEL_MANAGEMENT_SUB_TITLE")}
      />
      <RiskLevelManagementContentComponent />
      <SupportBlockComponent />
    </Box>
  );
};

export default RiskLevelManagementPage;
